import helper from '@/libs/forms';
import CODE_SCHEMA from '@/components/auth/forgot_pass/schemas/code';

export default {
  schema: onChangeCallback => ({
    fields: [
      Object.assign(helper.email(null, 'email', 'Email', true, 12), { onChanged: onChangeCallback }),
      CODE_SCHEMA.getCodeField(),
    ],
  }),
  options: helper.options('login-', false),
};



// WEBPACK FOOTER //
// ./src/components/auth/login/schema_verification.js